import _imageCompression from 'browser-image-compression';

import { get } from 'lodash';

import 'photoviewer/dist/photoviewer.css';
import PhotoViewer from 'photoviewer';

/*
export const onLoadImage = (url, title) => {
  const img = new Image();
  img.src = url;
  img.onload = () => {
    const windowSize = window.outerWidth || window.innerWidth || 1280
    const isOverSize = img.width > windowSize
    const img_width = isOverSize ? windowSize : img.width;
    // const win_width = img.width + 25;
    const height = img.height + 30;
    const OpenWindow = window.open(
      "",
      "",
      "width=" +
      img_width +
      ", height=" +
      height +
      ", menubars=no, location=no, status=no, titlebar=no, toolbar=no, scrollbars=auto"
    );

    OpenWindow.document.write(
      `<head><title>${title || "제목없음"
      }</title></head><style>body{margin:0px;}</style><img style="${isOverSize ? 'width:100%' : ''}"src="${url}">`
    );
  }
};
*/

export const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    /*
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (err) => reject(err));
    */
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
};

export const onLoadMultiImage = async (files, selected) => {

  const items = [];
  let index = 0;
  let count = 0;

  for (let i = 0; i < files.length; i++) {

    const url = get(files[i], "fileUrl");
    const title = get(files[i], "originalName");

    try {
      await loadImage(url);
      //console.log('item: ', url, title)

      items.push({
        src: url,
        title: title
      });

      if (i === selected) {
        index = count;
      }

      count++;
    } catch (e) { }
  }

  //console.log('items: ', items, index)

  if (items.length > 0) {
    new PhotoViewer(items, { index });
  }
};

export const isVerticalImg = (url) => {
  let isVertical = false;
  const img = new Image();
  img.src = url;

  const img_width = img.width;
  const img_height = img.height;

  if (img_height > img_width) isVertical = true;

  return isVertical;
};


export const imageCompression = async (image, options = {
  maxSizeMB: process.env.REACT_APP_MAX_UPLOAD_IMAGE_SIZE_MB || 1,
  maxWidthOrHeight: process.env.REACT_APP_MAX_UPLOAD_IMAGE_HEIGHT_PX || 1920,
  useWebWorker: true
}) => {
  try {
    const compressedFile = await _imageCompression(image, options);
    return compressedFile;
  } catch (error) {
    console.log(error);
    return image;
  }
};

export const toDataURL = (url, callback) => {
  let xhr = new XMLHttpRequest();
  xhr.onload = () => {
    let reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};

export const getImageHeight = async (file) => {
  const _URL = window.URL || window.webkitURL;
  const objectUrl = _URL.createObjectURL(file);
  const img = new Image();
  let height;

  img.onload = function() {
    height = this.height;
    _URL.revokeObjectURL(objectUrl);
  };
  img.src = objectUrl;
  return height;
};